import { useEffect } from 'react';

import { isEditableTarget } from 'utils/keyboard';

import { isModifierPressed } from './utils';

const useTeamChatShortcuts = ({ onOpen, onJumpToNextUnread }) => {
  useEffect(() => {
    const onKeyDown = e => {
      if (!isModifierPressed(e) || !e.shiftKey) {
        return;
      }

      if (isEditableTarget(e.target)) {
        return;
      }

      const key = e.key?.toLowerCase();

      if (key === 'm') {
        e.preventDefault();
        onOpen?.();

        return;
      }

      if (key === 'u') {
        e.preventDefault();
        onJumpToNextUnread?.();
      }
    };

    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onOpen, onJumpToNextUnread]);
};

export default useTeamChatShortcuts;
